<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('QUESTION_SOURCES.ACTIONS.EDIT.TITLE')"
      :header-content="$t('QUESTION_SOURCES.ACTIONS.EDIT.DESC')"
    />
    <form class="row" @submit.prevent="submitEditQuestion">
      <div class="header-right--wrap">
        <woot-button
          size="small"
          variant="smooth"
          color-scheme="primary"
          class-names="sub-block-title header-text"
          type="button"
          @click="
            () => (this.showDropdownCategories = !this.showDropdownCategories)
          "
        >
          <div class="select-category-wrap">
            <b>{{
             selectedCategory.name
                ? selectedCategory.name
                : $t('QUESTION_SOURCES.ACTIONS.ADD.SELECT_CATEGORY')
            }}</b>
            <img
              class="dropdown-icon-down"
              :class="{ rotate: this.showDropdownCategories }"
              src="/assets/images/sources/polygon-down.svg"
            />
          </div>
        </woot-button>
        <woot-dropdown-menu v-if="showDropdownCategories" class="question-dropdown">
          <woot-dropdown-sub-menu
            :title="this.$t('QUESTION_SOURCES.CATEGORY')"
            class-name="primary question-dropdown"
          >
            <woot-dropdown-item v-for="option in categories" :key="option.id">
              <woot-button
                size="small"
                variant="smooth"
                color-scheme="primary"
                class-names="sub-block-title header-text button-question-dropdown"
                type="button"
                @click="() => onSelectCategory(option)"
              >
                <div class="categories">
                  <input
                    id="checkbox"
                    type="checkbox"
                    :disabled="selectedCategory.id === option.id"
                    :checked="selectedCategory.id === option.id"
                  />
                  <div class="category-detail">
                    <span>
                      {{ option.name }}
                    </span>
                  </div>
                </div>
              </woot-button>
            </woot-dropdown-item>
          </woot-dropdown-sub-menu>
        </woot-dropdown-menu>
      </div>

      <div class="medium-12 columns question_input">
        <label>
          {{ $t('QUESTION_SOURCES.ACTIONS.EDIT.QUESTION.LABEL') }}
          <input
            v-model.trim="questionInput"
            type="text"
            :placeholder="$t('QUESTION_SOURCES.ACTIONS.EDIT.PLACEHOLDER')"
          />
        </label>
      </div>
      <div class="medium-12 columns">
        <label>
          {{ $t('QUESTION_SOURCES.ACTIONS.EDIT.RESPONSE.LABEL') }}
          <textarea
            v-model.trim="answerInput"
            type="text"
            class="response-text-area"
          />
        </label>
      </div>
      <div class="modal-footer">
        <div class="medium-12 columns">
          <woot-button :is-disabled="!(questionInput && answerInput)">
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.SUBMIT') }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t('DOCUMENT_SOURCES.ACTIONS.UPLOAD_DOCUMENT.CANCEL') }}
          </woot-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import WootDropdownItem from 'shared/components/ui/dropdown/DropdownItem.vue';
import WootDropdownMenu from 'shared/components/ui/dropdown/DropdownMenu.vue';
import WootDropdownSubMenu from 'shared/components/ui/dropdown/DropdownSubMenu.vue';
export default {
  name: 'EditQuestion',
  components: {
    WootDropdownMenu,
    WootDropdownItem,
    WootDropdownSubMenu,
  },
  mixins: [alertMixin],
  props: {
    currentCreate: {
      type: Object,
      default: () => {},
    },
    headerTitle: {
      type: String,
      default: '',
    },
    rowData: {
      id: Number,
      question: String,
      response: String,
      category: String,
    },
    categories: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      questionInput: '',
      showDropdownCategories: false,
      selectedCategory: {},
      answerInput: '',
      selectedName: ''
    };
  },
  computed: {
    // computed
  },
  mounted() {
    // Mounted
    if(this.rowData) {
      this.questionInput = this.rowData.question;
      this.answerInput = this.rowData.response;
      const selectedItem = this.categories.filter(element => {
        if(this.rowData.category === element.name) {
          return element
        }
      });

      if (selectedItem.length > 0) {
        this.selectedCategory = {
          id: selectedItem[0].id,
          name: selectedItem[0].name
        }
      }
    }
  },
  methods: {
    onClose() {
      this.resetData();
      this.$emit('close');
    },
    resetData() {
      // resetData
    },
    onSelectCategory(option) {
      this.selectedCategory = option;
      this.showDropdownCategories = false;
    },
    async submitEditQuestion() {
      try {
        await this.$store.dispatch('questions/update', {
          id: this.rowData.id,
          question: this.questionInput,
          answer: this.answerInput,
          category_id: !!this.selectedCategory && this.selectedCategory.id,
        });

        this.$emit('submit');
        this.showAlert(
          this.$t('QUESTION_SOURCES.ACTIONS.EDIT.API.SUCCESS_MESSAGE')
        );
        this.onClose();
      } catch (error) {
        this.showAlert(
          this.$t('QUESTION_SOURCES.ACTIONS.EDIT.API.UPLOAD_FAILED')
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';

.modal-footer {
  .button {
    margin-right: var(--space-small);
    margin-left: 0;
  }
}
.response-text-area {
  height: 250px;
  max-height: 250px;
}

.your_custom_class::v-deep .multiselect {
  .multiselect__tags {
    background-color: $color-primary-light;
  }
  .multiselect__placeholder {
    color: var(--w-500);
    font-weight: 700;
  }
}
.header-right--wrap {
  flex: none;
  align-items: center;
  position: relative;
  ul {
    position: absolute;
    width: 100%;
    background-color: var(--w-50);
    margin-top: var(--space-small);
  }
  .header-text {
    color: var(--w-500);
    width: 15em;

    &.button-question-dropdown {
      width: 100%;
      min-width: 15em;
      max-width: 300px;
    }
  }
  .categories {
    display: inline-flex;
    align-items: center;
    width: 100%;
  }
  .category-detail {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-right: var(--space-one);

    span {
      white-space: initial;
    }
  }

  [type='checkbox'] {
    width: var(--space-normal);
    height: var(--space-normal);
    color: var(--w-500);
    vertical-align: middle;
    -webkit-appearance: none;
    border-radius: 50%;
    background-color: var(--w-50);
    transition: background 300ms;
    cursor: pointer;
    margin-right: var(--space-small);
  }

  [type='checkbox']::before {
    content: '';
    color: transparent;
    display: block;
    width: inherit;
    height: inherit;
    border-radius: inherit;
    border: 0;
    background-color: transparent;
    background-size: contain;
    box-shadow: inset 0 0 0 1px var(--w-500);
  }

  [type='checkbox']:checked {
    background-color: currentcolor;
  }

  [type='checkbox']:checked::before {
    box-shadow: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cpath d='M15.88 8.29L10 14.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7a.996.996 0 0 0 0-1.41c-.39-.39-1.03-.39-1.42 0z' fill='%23fff'/%3E %3C/svg%3E");
  }
}
.select-category-wrap {
  display: flex;
  justify-content: space-around;
}
.question_input {
  margin-top: 20px;
}

.dropdown-icon-down {
  transition: transform 0.3s ease-in-out !important;
}

.dropdown-icon-down.rotate {
  transform: rotate(180deg);
}
</style>
